/* Enquire Now popup. Every a[href="#enquire"] or [data-enquire] opens the same form.
   The form posts JSON to the URL in data-endpoint. */
export function mountEnquire(root) {
  if (!root) return function () {};
  var dialog = root.querySelector("[data-enquire-dialog]");
  if (!dialog || typeof dialog.showModal !== "function") return function () {};
  var form = dialog.querySelector("form");
  if (!form) return function () {};

  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  var done = dialog.querySelector("[data-enquire-done]");
  var submit = form.querySelector('[type="submit"]');
  var alertBox = form.querySelector("[data-enquire-alert]");
  var message = form.elements.message;
  var counter = form.querySelector("[data-count]");
  var lastTrigger = null, closing = false, submitted = false;
  var cleanups = [];

  function on(target, type, fn, opts) {
    target.addEventListener(type, fn, opts);
    cleanups.push(function () { target.removeEventListener(type, fn, opts); });
  }

  var rules = {
    name: function (v) { return v.trim().length >= 2 ? "" : "Please enter your full name."; },
    email: function (v) {
      if (!v.trim()) return "Please enter your email address.";
      return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v.trim()) ? "" : "That email address doesn’t look right — please check it.";
    },
    phone: function (v) {
      if (!v.trim()) return "";
      var digits = v.replace(/\D/g, "");
      return /^[+()\d\s.-]+$/.test(v.trim()) && digits.length >= 7 && digits.length <= 15 ? "" : "Please enter a valid phone number, or leave it blank.";
    },
    organisation: function () { return ""; },
    message: function (v) { return v.trim().length >= 10 ? "" : "Please tell us a little more (at least 10 characters)."; },
    consent: function (v, el) { return el.checked ? "" : "Please confirm you’re happy for us to contact you."; }
  };

  function check(el, show) {
    var rule = rules[el.name];
    if (!rule) return true;
    var msg = rule(el.value, el);
    var wrap = el.closest(".field, .consent");
    var err = wrap && wrap.querySelector(".field__error");
    if (show && wrap) {
      wrap.classList.toggle("is-invalid", !!msg);
      el.setAttribute("aria-invalid", msg ? "true" : "false");
      if (err) err.textContent = msg;
    }
    return !msg;
  }

  Array.prototype.forEach.call(form.elements, function (el) {
    if (!el.name || !rules[el.name]) return;
    on(el, "blur", function () { if (el.value || el.dataset.touched) { el.dataset.touched = "1"; check(el, true); } });
    on(el, el.type === "checkbox" ? "change" : "input", function () {
      if (el.dataset.touched || el.closest(".is-invalid")) check(el, true);
    });
  });
  if (message && counter) {
    var max = message.maxLength > 0 ? message.maxLength : 1000;
    var updateCount = function () { counter.textContent = message.value.length + " / " + max; };
    on(message, "input", updateCount);
    updateCount();
  }

  function setLoading(isOn) {
    submit.disabled = isOn;
    submit.classList.toggle("is-loading", isOn);
    submit.querySelector("[data-label]").textContent = isOn ? "Sending…" : "Send enquiry";
  }

  on(form, "submit", function (e) {
    e.preventDefault();
    alertBox.hidden = true;
    var firstBad = null;
    Array.prototype.forEach.call(form.elements, function (el) {
      if (!el.name || !rules[el.name]) return;
      el.dataset.touched = "1";
      if (!check(el, true) && !firstBad) firstBad = el;
    });
    if (firstBad) { firstBad.focus(); return; }

    var data = {};
    Array.prototype.forEach.call(form.elements, function (el) {
      if (el.name) data[el.name] = el.type === "checkbox" ? el.checked : el.value.trim();
    });
    data.page = window.location.pathname.split("/").pop() || "index.html";
    var about = data.message || "";
    if (data.phone) about += "\nPhone: " + data.phone;
    about += "\nSource: Imprint.live website enquiry";

    var payload = {
      name: data.name,
      email: data.email,
      organization: data.organisation || "Not provided",
      subscriptions: "0",
      about: about
    };

    var endpoint = form.getAttribute("data-endpoint");
    setLoading(true);
    var finish = function (sent) {
      setLoading(false);
      submitted = true;
      var first = data.name.split(/\s+/)[0];
      done.querySelector("[data-done-title]").textContent = "Thanks, " + first + "!";
      done.querySelector("[data-done-text]").textContent = sent
        ? "We’ve received your enquiry and will reply to " + data.email + " soon."
        : "Your enquiry is complete and ready to go. This preview isn’t connected to an inbox yet, so nothing has been sent. Once the form is connected, the team will reply to " + data.email + ".";
      form.hidden = true;
      done.hidden = false;
      done.querySelector("button").focus();
    };
    if (!endpoint) { setTimeout(function () { finish(false); }, 700); return; }
    fetch(endpoint, { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify(payload) })
      .then(function (r) { if (!r.ok) throw new Error(r.status); finish(true); })
      .catch(function () {
        setLoading(false);
        alertBox.textContent = "We couldn’t send your enquiry just now. Please try again, or email platforms@thebuddyhood.com.";
        alertBox.hidden = false;
      });
  });

  function reset() {
    form.reset();
    form.hidden = false;
    done.hidden = true;
    alertBox.hidden = true;
    submitted = false;
    Array.prototype.forEach.call(form.querySelectorAll(".is-invalid"), function (n) { n.classList.remove("is-invalid"); });
    Array.prototype.forEach.call(form.elements, function (el) { delete el.dataset.touched; el.removeAttribute("aria-invalid"); });
    if (counter && message) message.dispatchEvent(new Event("input"));
  }

  function open(trigger) {
    if (dialog.open) return;
    lastTrigger = trigger || document.activeElement;
    if (submitted) reset();
    document.documentElement.classList.add("has-modal");
    dialog.classList.remove("is-closing");
    dialog.showModal();
    dialog.querySelector(".enquire__body").scrollTop = 0;
    setTimeout(function () { if (dialog.open) form.elements.name.focus({ preventScroll: true }); }, 80);
  }

  function close() {
    if (!dialog.open || closing) return;
    closing = true;
    var finishClose = function () {
      dialog.removeEventListener("animationend", finishClose);
      dialog.classList.remove("is-closing");
      dialog.close();
      closing = false;
      document.documentElement.classList.remove("has-modal");
      if (lastTrigger && lastTrigger.focus) lastTrigger.focus({ preventScroll: true });
    };
    if (reduceMotion.matches) { finishClose(); return; }
    dialog.classList.add("is-closing");
    dialog.addEventListener("animationend", finishClose);
    setTimeout(function () { if (closing) finishClose(); }, 400);
  }

  on(dialog, "cancel", function (e) { e.preventDefault(); close(); });
  on(dialog, "mousedown", function (e) { dialog._downOnBackdrop = e.target === dialog; });
  on(dialog, "click", function (e) {
    var r = dialog.getBoundingClientRect();
    var outside = e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom;
    if (e.target === dialog && outside && dialog._downOnBackdrop !== false) close();
  });
  dialog.querySelectorAll("[data-enquire-close]").forEach(function (b) { on(b, "click", close); });

  on(document, "click", function (e) {
    var t = e.target.closest('a[href="#enquire"], a[href$="index.html#enquire"], [data-enquire]');
    if (!t || dialog.contains(t)) return;
    e.preventDefault();
    open(t);
  });
  if (window.location.hash === "#enquire") setTimeout(function () { open(null); }, 300);

  return function () {
    cleanups.forEach(function (fn) { fn(); });
    if (dialog.open) dialog.close();
    document.documentElement.classList.remove("has-modal");
  };
}
